export enum FileTypeEnum {
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
}
